import React from 'react';
import { NavLink, Outlet, useOutletContext } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { trpcSwr } from '../../../api/trpc';
import { useSortingLocalStorage } from '../../../api/useSortingLocalStorage';

export type OutletContextParams = {
  debouncedInternalId: string;
};

export const CustomsDeliveryOrdersInWorkTab = () => {
  const intl = useIntl();
  const { debouncedInternalId } = useOutletContext<OutletContextParams>();
  const { sortValues } = useSortingLocalStorage();
  const tabs = [
    {
      title: intl.formatMessage({
        id: 'customsDeliveries.tab-label.codeSelected',
        defaultMessage: 'Подобрать код',
        description: 'Надпись на вкладке',
      }),
      path: 'codeSelected',
      name: 'codeSelected' as const,
    },
    {
      title: intl.formatMessage({
        id: 'customsDeliveries.tab-label.calculationReady',
        defaultMessage: 'Подготовить пред.расчет',
        description: 'Надпись на вкладке',
      }),
      path: 'calculationReady',
      name: 'calculationReady' as const,
    },
    {
      title: intl.formatMessage({
        id: 'customsDeliveries.tab-label.protectCalculation',
        defaultMessage: 'Защитить расчет',
        description: 'Надпись на вкладке',
      }),
      path: 'protectCalculation',
      name: 'protectCalculation' as const,
    },
  ];

  const { data } = trpcSwr.customsDelivery.totalByStatus.useSWR({
    searchValue: debouncedInternalId,
    linked: sortValues.linked,
  });

  const context: OutletContextParams = {
    debouncedInternalId: debouncedInternalId,
  };

  return (
    <>
      <ul className="nav nav-pills mb-4 d-inline-flex">
        {tabs.map((item) => (
          <li className="nav-item" key={item.title}>
            <NavLink to={item.path} className="nav-link text-decoration-none">
              {item.title} ({data ? data[item.name] || 0 : 0})
            </NavLink>
          </li>
        ))}
      </ul>

      <Outlet context={context} />
    </>
  );
};
